
<template>
    <div>
        <font-awesome-icon v-if="type == 'remove'" icon="heart-broken" class="text-base text-gray-600 hover:text-pastel-blue hover:cursor-pointer mt-1" @click="onClick" />
        <l-popup icon="heart" placement="bottom-start" class="mt-1 text-base" v-if="type == 'add'">
            <div class="text-sm flex flex-wrap select-none p-3">
                <l-input placeholder="Sett inn ett navn" v-model="label" class="bg-white" @keyup.enter.native="onClick">
                    <font-awesome-icon v-close-popover slot="suffix" icon="save" class="text-xl text-gray-600 hover:text-pastel-green-600 hover:cursor-pointer" @click="onClick" />
                </l-input>
            </div>
        </l-popup>
    </div>
</template>

<script>
    import LPopup from "@/components/LPopup";
    import { LInput } from "@/components/forms";
    import { VClosePopover } from "v-tooltip";
    import Notify from "@/helpers/notify";

    export default {
        name: "LLFav",
        components: {
            LPopup,
            LInput
        },
        props: ["type"],
        data() {
            return {
                label: ""
            };
        },
        directives: {
            "close-popover": VClosePopover
        },
        methods: {
            onClick() {
                if (this.type == 'remove') {
                    Notify.prompt(async response => {
                        if (response) {
                            this.$emit("click", { type: this.type, label: this.label });
                        }
                    }, "Er du sikker p&aring; at du vil fjerne denne favoritten?");
                } else {
                    this.$emit("click", { type: this.type, label: this.label });
                }
                this.label = "";
            }
        }
    };
</script>
